import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { API } from "../config/api-config";
import { CommonService } from "../service/common";
import { FileUpload } from "../service/file-upload";
import { Location } from "@angular/common";
import { HttpService } from "../service/http-service";

declare var alertify: any;

@Component({
  selector: "app-use-method-edit",
  templateUrl: "./use-method-edit.component.html",
  styleUrls: ["./use-method-edit.component.css"],
})
export class UseMethodEditComponent implements OnInit {
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private HttpService: HttpService,
    private location: Location,
    private fileupload: FileUpload,
    private common: CommonService
  ) {}

  private id: number = 0;

  public isCreate: boolean = false;

  public imagePath: string = "";

  private tempPath: string = API.getTemp;

  public data: any = {
    id: 0,
    imageEn: "",
    imageTc: "",
    nameTc: "",
    nameEn: "",
  };

  ngOnInit() {
    this.getPath();
    this.route.params.subscribe((params) => {
      this.id = params["id"];
      this.data.id = this.id;
    });
    if (this.id != 0) {
      this.getData();
    } else {
      this.isCreate = true;
    }
  }

  public submit(): void {
    const { id, imageEn, imageTc, nameEn, nameTc } = this.data;
    let data = { id, imageEn, imageTc, nameEn, nameTc };

    this.HttpService.postData(API.useMethod + "/update", data).then((res) => {
      let data = res;
      if (data.status.code == 0 || data.status.code == "0") {
        this.location.back();
      } else {
        alert(data.status.message);
      }
    });
  }

  private getData(): void {
    this.HttpService.getData(API.useMethod + "/" + this.id).then((res) => {
      this.data = res.data;
    });
  }

  public showimageEn = false;
  public showimageTc = false;

  private upload(name: string) {
    let self = this;
    this.fileupload.upload(function (res) {
      let temRes = JSON.parse(res);
      if (temRes.status.code == 0) {
        switch (name) {
          case "imageEn":
            self.showimageEn = true;
            break;
          case "imageTc":
            self.showimageTc = true;
            break;
        }
        self.data[name] = temRes.data.fileName;
      } else {
        alertify.error(temRes.status.message);
      }
    });
  }

  private getPath(): void {
    this.HttpService.getData(API.resourcePath).then((res) => {
      this.imagePath = res.data;
    });
  }
}



// WEBPACK FOOTER //
// /Users/ken/Dev/workspace/snowmantech/naturallyplus/web-cms/src/app/use-method-edit/use-method-edit.component.ts